import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as IcoDM } from 'assets/icons/Logo.svg'
import style from './Auth.module.css'

const Congratulation = () => {
  return (
    <div className={`${style.form}`}>
      <IcoDM className={`${style.logo}`} />
      <div className={`${style.congrats}`}>Congratulations</div>
      <div>
        You should receive an email shortly with further instructions.
      </div>

      <NavLink
        to="/login"
        className={`${style.submit}`}
      >
        Start Now!
      </NavLink>
    </div>
  )
}

export default Congratulation
